export default __webpack_public_path__ + "static/media/drawerclose.8b2c42f1.svg";